// extracted by mini-css-extract-plugin
export default {"section":"ADTporque_section__8oanU","boxes":"ADTporque_boxes__2Z8nm","box":"ADTporque_box__U4DYh","sec3":"ADTporque_sec3__S63jS"};